import VideoFlat from '../../src/legacy/VideoFlat';
export default VideoFlat;
